import { MetricListItemGrid } from "@/components/ListItem";

import MetricListItemSkeleton from "./MetricListItemSkeleton";

/**
 * Props for MetricListItemGridSkeleton component
 * @param items - Number of metric list items to display (default: 4)
 * @param className - Additional CSS classes. Pair with the same value on `MetricListItemGrid`.
 */
type MetricListItemGridSkeletonProps = {
  items?: number;
  className?: string;
};

export default function MetricListItemGridSkeleton({ items = 4, className }: MetricListItemGridSkeletonProps) {
  return (
    <MetricListItemGrid className={className} testId="metric-list-item-grid-skeleton">
      {Array.from({ length: items }).map((_, index) => (
        <MetricListItemSkeleton key={index} />
      ))}
    </MetricListItemGrid>
  );
}
